import { useMemo } from "react";

import { useAudienceContext } from "@/context";
import { getAudienceBreadcrumb, getActivationBreadcrumb } from "@/utils";
import { ActivePage } from "@/types";


export const Breadcrumbs = (
  activePage: ActivePage | null,
  pagePath: string
) => {
  const { state } = useAudienceContext();

  return useMemo(() => {

    if (!activePage) return [];

    if (['Audiences', 'Upload', 'Mindsets', 'Sites', 'Audience Library'].includes(activePage.title)) {
      return getAudienceBreadcrumb(
        activePage,
        pagePath,
        state.currentAudience,
        state.loading
      );
    } else {
      return getActivationBreadcrumb(
        activePage,
        pagePath,
        state.currentActivation,
        state.loading
      );
    }

  }, [activePage, pagePath, state.currentAudience, state.currentActivation, state.loading]);
};
